'use strict';

var d3 = require('d3');
var Lines = function Lines() {
  return function () {
    var scales;
    var container;
    var line = d3.svg.line();
    var lines = function lines(_container_) {
      container = _container_;
      var currentSeatsAvail = container.datum()[0].currentSeatsAvail;
      var xCurrentSeats = scales.xScale(currentSeatsAvail);
      container.select('.x-current-line').remove();
      container.selectAll('.line').remove();
      container.append('line').attr('class', 'x-current-line').attr('y1', scales.yScale(scales.yScale.domain()[0])).attr('y2', scales.yScale(scales.yScale.domain()[1])).attr('x1', xCurrentSeats).attr('x2', xCurrentSeats);
      var path = container.append('path').attr('class', 'line');
      line.x(function (d) {
        return scales.xScale(d.seatAvailIndex);
      }).y(function (d) {
        return scales.yScale(d.bidPrice);
      });
      path.attr('d', line);
    };
    lines.scales = function (value) {
      if (!arguments.length) {
        return scales;
      }
      scales = value;
      return lines;
    };
    return lines;
  };
};
Lines.$inject = [];
module.exports = Lines;